import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selected", "scroller", "fadeLeft", "fadeRight", "previous", "next"]

  connect() {
    if (this.hasSelectedTarget && this.hasScrollerTarget) {
      const selectedRect = this.selectedTarget.getBoundingClientRect()
      const scrollerRect = this.scrollerTarget.getBoundingClientRect()
      const selectedCenter = selectedRect.left + selectedRect.width / 2
      const scrollerCenter = scrollerRect.left + scrollerRect.width / 2

      this.scrollerTarget.scrollLeft += selectedCenter - scrollerCenter
    }

    requestAnimationFrame(() => this.updateFades())

    if (this.hasScrollerTarget) {
      this.resizeObserver = new ResizeObserver(() => this.updateFades())
      this.resizeObserver.observe(this.scrollerTarget)
    }
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  scrollBackward() {
    this.scroll(-1)
  }

  scrollForward() {
    this.scroll(1)
  }

  updateFades() {
    if (!this.hasScrollerTarget) return

    const el = this.scrollerTarget
    const scrollLeft = el.scrollLeft
    const maxScroll = el.scrollWidth - el.clientWidth

    if (this.hasFadeLeftTarget) {
      this.fadeLeftTarget.style.opacity = scrollLeft > 2 ? "1" : "0"
    }

    if (this.hasFadeRightTarget) {
      this.fadeRightTarget.style.opacity = scrollLeft < maxScroll - 2 ? "1" : "0"
    }

    if (this.hasPreviousTarget) {
      this.updateControl(this.previousTarget, scrollLeft <= 2)
    }

    if (this.hasNextTarget) {
      this.updateControl(this.nextTarget, maxScroll <= 2 || scrollLeft >= maxScroll - 2)
    }
  }

  scroll(direction) {
    if (!this.hasScrollerTarget) return

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

    this.scrollerTarget.scrollBy({
      behavior: reduceMotion ? "auto" : "smooth",
      left: direction * this.scrollerTarget.clientWidth * 0.8,
    })
  }

  updateControl(control, disabled) {
    control.disabled = disabled
    control.setAttribute("aria-disabled", disabled.toString())
  }
}
